const ErrorPage = () => {
  return <div>Something went wrong. Refresh the page</div>;
};

export default ErrorPage;
